(() => {
  const OPEN_CLASS = "wild-inbox-chat-open";
  const INIT_ATTR = "data-wit-initialized";
  const STORAGE_PREFIX = "wild_inbox_teaser_hidden_";

  function getHost() {
    return (
      document.querySelector("inbox-online-store-chat#ShopifyChat") ||
      document.querySelector("inbox-online-store-chat") ||
      document.querySelector("#shopify-chat")
    );
  }

  function findControlButton(root) {
    if (!root) return null;
    return root.querySelector(
      [
        ".chat-toggle",
        "button.chat-toggle",
        ".chat-app>button",
        '.chat-app button[aria-controls="chat-ui"]',
        '.chat-app button[data-spec="toggle-button"]',
        'button[aria-controls="chat-ui"]',
        "#shopify-chat button",
      ].join(",")
    );
  }

  function getControlButton() {
    // document
    let btn = findControlButton(document);
    if (btn) return btn;

    // host + shadowRoot
    const host = getHost();
    if (!host) return null;

    btn = findControlButton(host);
    if (btn) return btn;

    if (host.shadowRoot) {
      btn = findControlButton(host.shadowRoot);
      if (btn) return btn;
    }

    return null;
  }

  function isChatOpen(btn) {
    return btn && btn.getAttribute("aria-expanded") === "true";
  }

  function syncOpenClass(open) {
    document.documentElement.classList.toggle(OPEN_CLASS, !!open);
    const host = getHost();
    if (host && host.setAttribute) host.setAttribute("is-open", open ? "true" : "false");
  }

  function openChat() {
    const btn = getControlButton();
    syncOpenClass(true);
    if (btn && !isChatOpen(btn)) btn.click();
  }

  function closeChat() {
    const btn = getControlButton();
    if (btn && isChatOpen(btn)) btn.click();
    syncOpenClass(false);
  }

  function initTeaser(teaser) {
    if (!teaser || teaser.hasAttribute(INIT_ATTR)) return;
    teaser.setAttribute(INIT_ATTR, "true");

    const bubbleWrap = teaser.querySelector("[data-bubble]");
    const closeBubbleBtn = teaser.querySelector("[data-close]");
    const openChatLink = teaser.querySelector("[data-open-chat]");
    const avatarBtn = teaser.querySelector("[data-avatar]");

    const storageKey = STORAGE_PREFIX + (teaser.id || "default");

    function setBubbleVisible(visible, persist = false) {
      if (!bubbleWrap) return;
      bubbleWrap.style.display = visible ? "" : "none";
      if (persist) {
        if (visible) localStorage.removeItem(storageKey);
        else localStorage.setItem(storageKey, "1");
      }
    }

    // no flash
    setBubbleVisible(false, false);
    syncOpenClass(false);

    // boot: wacht tot Shopify Inbox knop er is
    let tries = 0;
    const boot = setInterval(() => {
      tries += 1;
      const btn = getControlButton();
      if (!btn && tries < 60) return;

      const open = isChatOpen(btn);
      syncOpenClass(open);

      if (open) {
        setBubbleVisible(false, false);
      } else if (localStorage.getItem(storageKey) !== "1") {
        setBubbleVisible(true, false);
      }
      clearInterval(boot);
    }, 200);

    closeBubbleBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      setBubbleVisible(false, true);
    });

    openChatLink?.addEventListener("click", (e) => {
      e.preventDefault();
      openChat();
      setBubbleVisible(false, false);
    });

    avatarBtn?.addEventListener("click", (e) => {
      e.preventDefault();

      const btn = getControlButton();
      const open = isChatOpen(btn);

      if (open) {
        closeChat();
        if (localStorage.getItem(storageKey) !== "1") setBubbleVisible(true, false);
        return;
      }

      const bubbleHidden = bubbleWrap && bubbleWrap.style.display === "none";
      if (bubbleHidden) {
        setBubbleVisible(true, true);
      } else {
        openChat();
        setBubbleVisible(false, false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-wild-inbox-teaser]").forEach(initTeaser);
  }

  // init on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify theme editor / rerenders
  document.addEventListener("shopify:section:load", initAll);

  // keep open state synced
  const mo = new MutationObserver(() => {
    const btn = getControlButton();
    syncOpenClass(isChatOpen(btn));
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
